import script from "./3gauges.vue?vue&type=script&setup=true&lang=js"
export * from "./3gauges.vue?vue&type=script&setup=true&lang=js"

import "./3gauges.vue?vue&type=style&index=0&id=26fd9840&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fd9840"]])

export default __exports__